export const REACH_OUT_TO_BENCHLING_TEXT = 'Please reach out to Benchling Support for additional help.';
export const FAILED_STEP_MESSAGE = 'This action is unavailable because of an error';
